import { ReactElement } from 'react'
import { Badge, BadgeProps } from '@mui/material'
import { SxProps, Theme } from '@mui/material/styles'

export interface CountBadgeProps {
  count: number
  children?: ReactElement
  color?: BadgeProps['color']
  max?: number
  overlap?: BadgeProps['overlap']
  anchorOrigin?: BadgeProps['anchorOrigin']
  sx?: SxProps<Theme>
}

// Deliberately thin - the app's count badges span visually distinct
// families (flat sidebar badge, plain notification-bell badge, gradient
// activity badges) with no shared base styling that's safe to bake in, so
// each call site still supplies its own exact sx.
const CountBadge = ({ count, children, color, max, overlap, anchorOrigin, sx }: CountBadgeProps) => (
  <Badge
    badgeContent={count}
    color={color}
    max={max}
    overlap={overlap}
    anchorOrigin={anchorOrigin}
    sx={sx}
  >
    {children}
  </Badge>
)

export default CountBadge
